import { installDictionary, type Lang } from "@/i18n";

/**
 * Fetches one language's dictionary as its own chunk and installs it. Only the
 * language in use is downloaded; switching reloads the page, so labels
 * built at import time never need to change in place.
 */
export async function loadDictionary(lang: Lang): Promise<void> {
  const mod = lang === "id" ? await import("./catalogues/id") : await import("./catalogues/en");
  installDictionary(lang, mod.default);
}
